import React from 'react'
// import {
//   Radio
// } from '../../../components'
import {
  JourneyPopup,
  JourneyTable,
} from '.';
import { Plus } from 'react-feather';

const FormJourney = ({form, updateForm, isMobile}) => {
  const [popedUpJourney, setPopedUpJourney] = React.useState(false)

  return (
    <div>
      <div className="flex justify-between items-start lg:items-center mb-5 lg:mb-8">
        <div className="flex flex-wrap items-center">
          <p className="w-full lg:w-auto text-lg font-bold mb-2 lg:mb-0">Journey</p>
          {/* <div className="hidden lg:block mx-5">|</div>
          <div className="flex items-center">
            <p className="text-sm font-bold mr-4">Visibility:</p>
            <Radio
              name="journey_visibility"
              id="journey_visibility1"
              label="Public"
              value="public"
              className="mr-4"
              form={form}
              onChange={updateForm}
            />
            <Radio
              name="journey_visibility"
              id="journey_visibility2"
              label="Only me"
              value="onlyme"
              form={form}
              onChange={updateForm}
            />
          </div> */}
        </div>
        <div
          className="text-sm text-primary flex items-center cursor-pointer whitespace-no-wrap"
          onClick={() => setPopedUpJourney(true)}
        >
          <Plus className="lg:mr-1" style={{width: isMobile ? '18px' : '14px'}}/>
          <p className="whitespace-no-wrap">Add <span className="hidden lg:inline">journey</span></p>
        </div>
      </div>
      <div className="mobile-fullwidth">
        <JourneyTable onEdit={() => setPopedUpJourney(true)} />
      </div>
      {
        popedUpJourney &&
        <JourneyPopup onClose={setPopedUpJourney}/>
      }
    </div>
  )
}

export { FormJourney }